export const MODIFY_ARIA_LABEL = 'Modify';
export const UPDATE_ARIA_LABEL = 'Update';
export const INFO_ARIA_LABEL = 'Info';
export const DELETE_ARIA_LABEL = 'Delete';
